<!--  -->
<template>
  <div class="footer">
    <div class="trains">
      <div class="footer-left">
        <div class="tipsc">联系我们</div>
        <div>服务热线：400-158-7877</div>
        <div>企业地址：浙江省杭州市钱塘区下沙街道学源街1366号3幢1701室</div>
      </div>

      <div class="footer-middle">
        <div>新闻资讯</div>
        <div>城市合伙人</div>
        <div>公司简介</div>
        <div>加入我们</div>
      </div>
      <div class="heatRay">
        <div>客服热线</div>
        <div class="hotLine">
          <div class="img"></div>
          400-158-7877
        </div>
      </div>
      <div class="footerRight">
        <img src="@/assets/Frame507.png" alt="" class="img1" />
        <img src="@/assets/erweima1.png" alt="" class="img2" />
        微信公众号
      </div>
    </div>
    <div class="btn">
      <div>浙江良巧匠网络科技有限公司 版权所有(C)2023</div>
      <div class="m20">
        <a href="https://beian.miit.gov.cn/" target="_blank" class="beian-link"
          >浙ICP备2023021504号
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.footer {
  background: #141414;
}
.trains {
  display: flex;
  justify-content: space-between;
  padding: 112px 360px 30px 360px;
}
.footer-left {
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  text-align: left;
  .tipsc {
    font-weight: bold;
    font-size: 14px;
    color: #ffffff;
  }
  div {
    margin-bottom: 30px;
  }
}
.footer-middle {
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #ffffff;
  text-align: left;
  div {
    margin-bottom: 30px;
  }
}
.heatRay {
  font-family: PingFang SC, PingFang SC;
  font-weight: bold;
  font-size: 14px;
  color: #ffffff;
  .hotLine {
    .img {
      width: 22px;
      height: 22px;
      background-image: url("@/assets/erweima.png");
      background-size: cover; /* 图片覆盖整个容器，但可能裁剪 */
      background-position: center; /* 图片居中显示 */
      background-repeat: no-repeat; /* 不重复背景图像 */
    }

    display: flex;
    font-family: DIN, DIN;
    font-weight: 500;
    font-size: 22px;
    color: #ff9500;
    margin-top: 10px;
    display: flex;
    align-items: center;
  }
}
.footerRight {
  font-family: Microsoft YaHei UI, Microsoft YaHei UI;
  font-weight: 400;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 22px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  .img1 {
    width: 160px;
    height: 60px;
    margin-bottom: 20px;
  }
  .img2 {
    width: 100px;
    height: 100px;
    margin-bottom: 6px;
  }
}
.trains {
  padding-bottom: 76px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.btn {
  font-family: Microsoft YaHei UI, Microsoft YaHei UI;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  display: flex;
  padding: 30px 0;
  justify-content: center;
}
.m20 {
  margin-left: 20px;
  a {
    color: #ffffff;
  }
}

/* 在小屏幕上使用单列布局 */
@media (max-width: 768px) {
  .trains {
    padding: 112px 240px 30px 240px;
  }
}
</style>
